import logoLoaderGif from 'assets/gif/logo-loader.gif';
import logoLoaderDarkGif from 'assets/gif/logo-loader-dark.gif';

import { Box } from '@cast/design-system';

export const LogoLoader = () => {
  return (
    <Box
      height={100}
      width={100}
      data-testid="logo-loader"
      sx={{
        position: 'relative',
        '& img': {
          position: 'absolute',
          inset: 0,
          display: 'block',
        },
        '& .logo-loader-dark': {
          display: 'none',
        },
        'html[data-theme="dark"] & .logo-loader-light': {
          display: 'none',
        },
        'html[data-theme="dark"] & .logo-loader-dark': {
          display: 'block',
        },
      }}
    >
      <img
        className="logo-loader-light"
        src={logoLoaderGif}
        alt="Loading"
        height={100}
        width={100}
      />
      <img
        className="logo-loader-dark"
        src={logoLoaderDarkGif}
        alt="Loading"
        height={100}
        width={100}
      />
    </Box>
  );
};
